module.exports = __webpack_public_path__ + "media/images/playbook_notifications-20fb3281ee6f89413ee01bca5f121e1d.svg";